var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staff-container" },
    [
      _c(
        "prescriptionFilter",
        { ref: "prescriptionFilter" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function($event) {
                  return _vm.handleQuery()
                }
              }
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", size: "small" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v("添加")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.typeChange },
              model: {
                value: _vm.checkType,
                callback: function($$v) {
                  _vm.checkType = $$v
                },
                expression: "checkType"
              }
            },
            [
              _vm._l(_vm.$config.checkType, function(tab) {
                return _c("el-tab-pane", {
                  key: tab.key,
                  attrs: { name: tab.key, label: tab.name }
                })
              }),
              _c("el-tab-pane", {
                key: "None",
                attrs: { name: "None", label: "其他" }
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tab-content" },
        [
          _c("prescriptionList", {
            ref: "prescriptionList",
            attrs: { filter: _vm.filter }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }